(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("secondaryLanguages", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/general/languages/secondary/secondaryLanguagesView.html",
            controller: ["tenantResource", "$rootScope", "messageService", SecondaryLanguagesCtrl],
            controllerAs: "vm"
        };
        function SecondaryLanguagesCtrl(tenantResource, $rootScope, messageService) {
            var vm = this;
            vm.saving = false;
            tenantResource.getLanguages(function (data) {
                vm.model = data;
            });
            vm.save = function () {
                vm.saving = true;
                tenantResource.saveLanguages(vm.model, function () {
                    messageService.success("settings.general.languages.secondaryLanguages.save.success");
                    vm.saving = false;
                    $rootScope.$broadcast("reloadTenantSettings");
                }, function () {
                    messageService.error("common.genericError");
                    vm.saving = false;
                });
            };
        }
    });
})();
